import React, { Component } from "react";
import { connect } from "react-redux";
import TableItem from "../../../Components/TableItem";
import ButtonItem from "../../../Components/ButtonItem";
import { PageHeader, Popconfirm, message, Tooltip, Tag } from "antd";
import { EditOutlined  , CheckSquareTwoTone,
  CloseSquareTwoTone, } from "@ant-design/icons";
import { CheckCircleOutlined, StopOutlined } from "@ant-design/icons";
import SegmentedItem from "../../../Components/SegmentedItem";
import axios from "axios";
import ModalMarca from "./ModalMarca/ModalMarca";

class Marcas extends Component {
  state = {
    loading: false,
    todasMarcas: [],
    modalMarca: false,
    modoModal: "",
    marcaId: null,
    valor: 1,
  };

  componentDidMount() {
    this.consultarMarcasPorEmpresa();
  }
  //Función para consultar las marcas de la empresa
  consultarMarcasPorEmpresa = async () => {
    this.setState({ loading: true });
    axios
      .post(
        "marcas/selectTodasMarcas",
        {
          empresaId: this.props.empresaId,
          estado: this.state.valor,
        },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        const data = res.data;

        this.setState({ loading: false });
        if (data.success === 2 && Array.isArray(data.marcas)) {
          this.setState({ todasMarcas: data.marcas });
        } else {
          this.setState({ todasMarcas: [] });
          console.warn("No se encontraron marcas o respuesta inválida:", data);
        }
      })
      .catch((error) => {
        console.error("Error al consultar marcas por empresa:", error);
        this.setState({ todasMarcas: [] });
      });
  };
  //Funciones para cambiar el estado del formulario
  habilitarMarca = (marcaId) => {
    this.setState({ loading: true });
    axios
      .post(
        "marcas/habilitarMarca",
        { marcaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        const data = res.data;
        this.setState({ loading: false });

        if (data.success === 2) {
          message.success("Marca habilitada correctamente");
          this.consultarMarcasPorEmpresa(); // Recargar la lista
        } else {
          message.error("No se pudo habilitar la marca");
          console.warn("Respuesta inesperada al habilitar marca:", data);
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error("Error al habilitar la marca:", error);
        message.error("Ocurrió un error al habilitar la marca");
      });
  };

  deshabilitarMarca = (marcaId) => {
    this.setState({ loading: true });
    axios
      .post(
        "marcas/deshabilitarMarca",
        { marcaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        const data = res.data;
        this.setState({ loading: false });

        if (data.success === 2) {
          message.success("Marca deshabilitada correctamente");
          this.consultarMarcasPorEmpresa(); // Recargar la lista
        } else {
          message.error("No se pudo deshabilitar la marca");
          console.warn("Respuesta inesperada al deshabilitar marca:", data);
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error("Error al deshabilitar la marca:", error);
        message.error("Ocurrió un error al deshabilitar la marca");
      });
  };

  //Funciones para  cerrar formulario de agregar

  cerrarModalMarca = () => {
    this.setState({ modalMarca: false });
    this.consultarMarcasPorEmpresa();
  };

  // Abrir modal en modo agregar
  agregarMarca = () => {
    this.setState({
      modoModal: "agregar",
      marcaId: null,
      modalMarca: true,
    });
  };

  // Abrir modal en modo editar
  editarMarca = (id) => {
    this.setState({
      modoModal: "editar",
      marcaId: id,
      modalMarca: true,
    });
  };

  // Ir a la pantalla de importar marcas
  importarMarcas = () => {
    this.props.history.push('/panel/importarMarcas');
  };
  render() {
    const columns = [
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        buscar: "clave",
        render: (value) => value || "",
        sorter: (a, b) => {
          if (a.clave < b.clave) {
            return -1;
          }
          if (a.clave > b.clave) {
            return 1;
          }
          return 0;
        },
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        buscar: "nombre",
        render: (value) => value || "",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        buscar: "descripcion",
        render: (value) => value || "",
      },
      {
        title: "Sitio Web",
        dataIndex: "sitioWeb",
        key: "sitioWeb",
        render: (value) => value || "",
      },
      {
        title: "Logo Cargado",
        dataIndex: "logo",
        key: "logo",
        render: (value) =>
          value ? (
            <CheckSquareTwoTone
              twoToneColor={["rgb(144, 225, 22)", "#f4fef0"]}
              style={{ fontSize: 20 }}
            />
          ) : (
            <CloseSquareTwoTone
              twoToneColor={["rgb(174, 174, 174)", "#f2f2f2"]}
              style={{ fontSize: 20 }}
            />
          ),
        align: "center",
        width: "7%",
      },
      {
        title: "Calculo Automatico",
        dataIndex: "noCalcularPreciosAutomaticamente",
        key: "noCalcularPreciosAutomaticamente",
        render: (value) =>
          value ? <Tag color="orange">Apagado</Tag> : <Tag>Normal</Tag>,
        align: "center",
        width: "9%",
      },
      {
        title: "Proveedor Principal",
        dataIndex: "proveedor",
        key: "proveedor",
        buscar: "proveedor",
      },
      {
        title: "Acción",
        key: "acciones",
        fixed: "right",
        align: "center",
        onHeaderCell: () => ({
          style: { textAlign: "center", padding: "4px" },
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: "center", padding: "4px" },
        }),
        render: (value, index) => {
          let buttons = [];

          // Botón Editar
          buttons.push(
            <Tooltip
              title="Editar Marca"
              placement="top"
              overlayInnerStyle={{
                fontSize: "10px",
                padding: "1px 5px",
                minHeight: "auto",
              }}
            >
              <ButtonItem
                key={`editar-${index}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.editarMarca(value._id)}
              ></ButtonItem>
            </Tooltip>,
          );

          // Botón Habilitar/Deshabilitar
          if (value.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${index}`}
                title="¿Estás seguro de deshabilitar esta marca?"
                onConfirm={() => this.deshabilitarMarca(value._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Deshabilitar"
                  placement="top"
                  overlayInnerStyle={{
                    fontSize: "10px",
                    padding: "1px 5px",
                    minHeight: "auto",
                  }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  ></ButtonItem>
                </Tooltip>
              </Popconfirm>,
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${index}`}
                title="Seguro que quieres habilitar esta marca"
                onConfirm={() => this.habilitarMarca(value._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip
                  title="Habilitar"
                  placement="top"
                  overlayInnerStyle={{
                    fontSize: "10px",
                    padding: "1px 5px",
                    minHeight: "auto",
                  }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  ></ButtonItem>
                </Tooltip>
              </Popconfirm>,
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Marcas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Activo", value: 1 },
                    { label: "Deshabilitado", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    this.setState({ valor: value }, () => {
                      this.consultarMarcasPorEmpresa();
                    });
                  }}
                />
              )}

              <ButtonItem
                type="default"
                key="importar"
                onClick={this.importarMarcas}
                className="botonAgregar"
              >
                Importar Marcas
              </ButtonItem>

              <ButtonItem
                type="primary"
                key=""
                onClick={this.agregarMarca}
                olivo
                className="botonAgregar"
              >
                Agregar Marca
              </ButtonItem>
            </>
          }
        />
        <TableItem
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasMarcas}
          columns={columns}
          pagination={true}
          onRow={(record) => ({
            onDoubleClick: () => {
              //this.verFormularioSoloLectura(record._id)
            },
          })}
        />

        <ModalMarca
          visible={this.state.modalMarca}
          onClose={this.cerrarModalMarca}
          empresaId={this.props.empresaId}
          usuarioId={this.props.usuarioId}
          headersToken={this.props.headersToken}
          modo={this.state.modoModal}
          marcaId={this.state.marcaId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    usuarioId: state.user.usuarioId,
  };
};

export default connect(mapStateToProps)(Marcas);
